import { FC } from 'react';
import classNames from 'classnames';

import { SlideoutBackButton } from 'components/design-system/Slideout';
import styles from 'styles/Auctions.module.scss';

export const MaxBidExplanationTestIds = {
  container: 'max-bid-explanation-container'
};

export type MaxBidExplanationProps = {
  goBack: () => void;
};

export const MaxBidExplanation: FC<MaxBidExplanationProps> = ({ goBack }) => (
  <div
    data-testid={MaxBidExplanationTestIds.container}
    className='text-light d-flex flex-column align-items-center riforma-regular pt-2'
  >
    <div className='w-100'>
      <SlideoutBackButton isDark onClickPrevious={goBack} />
    </div>
    <div className='fs-18px fs-sm-20px'>What’s a max bid?</div>
    <div className='opacity-60 px-3 my-4 text-center'>
      Once you set your maximum bid price, the system will automatically place incremental minimum bids up to your max
      bid
    </div>
    <div className='opacity-40 fs-12px letter-spacing-08'>TWO STRATEGIES</div>
    <div className={classNames(styles.box, 'my-3 p-3')}>
      <div className='fs-16px mb-3 mt-1'>Active bidding</div>
      <div className='opacity-60'>
        You can take a hands on approach and just bid the minimum to get the highest bid position every time you are
        incrementally out bid
      </div>
    </div>
    <div className='opacity-40 fs-12px letter-spacing-08'>OR</div>
    <div className={classNames(styles.box, 'my-3 p-3')}>
      <div className='fs-16px my-3'>Hands-off, max bidding</div>
      <div className='opacity-60'>
        You set your maximum bid price, let’s say it’s $10,000. The system will incrementally bid the minimum to keep
        the highest position, automatically. The system will try to get you the lowest price possible, but will insure
        that you don’t miss any bidding opportunities.
      </div>
    </div>
  </div>
);
